/**
 * Created by Ning Jiang on 11/17/2016.
 */



import ("pixi.js");
declare global {
    interface Window {
        PIXI:any;
    }
}

import * as PIXI from "pixi.js";
window.PIXI = PIXI;
require ("pixi-spine");

import {NolimitLauncher} from "@nolimitcity/slot-launcher/bin/NolimitLauncher";
import {SlotKeypad} from "@nolimitcity/slot-keypad/bin/SlotKeypad";
import {NolimitPromotionPlugin} from "@nolimitcity/promo-panel/bin/NolimitPromotionPlugin";
import {Thor} from "./game/Thor";
import {NolimitSlotAudio} from "@nolimitcity/slot-audio/bin/NolimitSlotAudio";

declare global {
    interface Window { NolimitLauncher: NolimitLauncher;}
}
window.NolimitLauncher = NolimitLauncher.instance;
import {ThorPromoPanelConfig} from "./game/ThorPromoPanelConfig";
NolimitLauncher.instance.launch([
    new Thor(),
    new SlotKeypad(),
    new NolimitSlotAudio(),
    new NolimitPromotionPlugin(new ThorPromoPanelConfig())
]);